import { HttpRequest, HttpHandlerFn, HttpEvent } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { BusinessContextService } from '../services/business-context.service';

/**
 * headersInterceptor
 * ──────────────────
 * Agrega automáticamente los headers de contexto multi-tenant en cada request:
 *
 *  X-Business-Id  → ID del negocio activo (para que el backend resuelva permisos)
 *  Accept-Language → Idioma del cliente
 *
 * El backend (JwtStrategy) usa X-Business-Id para cargar la membresía correcta
 * y resolver los permisos del usuario de forma directa.
 */
export function headersInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> {
  const bizCtx = inject(BusinessContextService);

  const headers: Record<string, string> = {
    'Accept-Language': 'es',
  };

  const token = localStorage.getItem('auth_token');
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  // ── Contexto de negocio ───────────────────────────────────────────────────
  const business = bizCtx.business();
  if (business) {
    headers['X-Business-Id'] = business;
  }

  const cloned = req.clone({ setHeaders: headers });
  return next(cloned);
}
